import { CARD_TYPES } from '../config/dashboardConfig';

/**
 * 카드 타입별 고유 UUID 매핑
 * 각 카드 타입에 대해 고정된 UUID를 할당
 * 이 UUID는 변하지 않는 카드의 고유 식별자입니다.
 */
const CARD_ID_TO_UUID_MAP = {
  [CARD_TYPES.CURRENT_DISPATCH]: '51140ee4-93f1-43f1-924c-0e2a503b4880',
  [CARD_TYPES.DR_HISTORY]: '0576f45f-7b7d-47ce-8c64-c070b096915d',
  [CARD_TYPES.DR_LATEST_DISPATCH]: '87b29fbc-e10a-4ce4-97e1-e59e186789bc',
  [CARD_TYPES.POWER_PRICE]: '1d834b6c-c929-40b2-86ef-82f58c9607c6',
  [CARD_TYPES.DR_RESOURCE]: '5d7ba6f7-5ca0-4530-bf54-e82fbf1051e0',
  [CARD_TYPES.EV_STATION]: '64803388-16b4-4f4c-8e56-b22510d7dc90',
  [CARD_TYPES.EV_CHARGER]: 'fb9b4f51-f6f5-4386-acf6-11e8a24bcbc3',
  [CARD_TYPES.WEATHER]: '0f8bac4b-c90c-4ad4-ad9c-8cabc5508b67',
  [CARD_TYPES.CHARGING_DEMAND]: 'a0baa213-a36b-4ee3-a988-18d2c925cc74',
  [CARD_TYPES.OPM_CONTRACT_SUMMARY]: 'c7e2f1a0-8b3d-4c5e-9f6a-0d1e2f3a4b5c',
};

/**
 * UUID로 카드 타입을 조회하기 위한 역매핑
 */
const UUID_TO_CARD_ID_MAP = Object.entries(CARD_ID_TO_UUID_MAP).reduce((acc, [cardType, uuid]) => {
  acc[uuid] = cardType;
  return acc;
}, {});

/**
 * 카드 타입으로 UUID 조회
 * @param {string} cardType - 카드 타입 (CARD_TYPES.*)
 * @returns {string|null} UUID
 */
export const getCardUuid = (cardType) => {
  return CARD_ID_TO_UUID_MAP[cardType] || null;
};

/**
 * UUID로 카드 타입 조회
 * @param {string} uuid - 카드 위젯 위치 UUID
 * @returns {string|null} 카드 타입
 */
export const getCardTypeByUuid = (uuid) => {
  return UUID_TO_CARD_ID_MAP[uuid] || null;
};

/**
 * 모든 카드 UUID 맵 조회
 * @returns {Object} { cardType: uuid } 형식의 객체
 */
export const getAllCardUuidMap = () => {
  return { ...CARD_ID_TO_UUID_MAP };
};

